module.exports = __webpack_public_path__ + "static/media/sunset-investing-screenshot-11.d380f76d.jpg";